<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Attendees" childName="View Guests"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading title="Guest lists"></heading>

        <button class="btn" @click="showPopup = !showPopup">
          <img class="white_icon" src="@/assets/img/plus.svg" />Add Guest
        </button>

        <div>
          <div class="info-search">
            <div :style="{ display: 'flex', flexDirection: 'column' }">
              <span>Guests: {{ guests.length }}</span>
              <span>Invites Sent:</span>
              <span>Total Attending:</span>
            </div>
            <input
              class="search-inp"
              type="text"
              @input="handleSearch"
              placeholder="Search Attendees"
            />
          </div>
          <table>
            <thead>
              <td>Select</td>
              <td>Attendee's Name</td>
              <td>Email</td>
              <td>Attending</td>
              <!-- <td>Check-In</td> -->
              <td></td>
            </thead>

            <tbody>
              <tr v-for="(person, index) in guests" :key="index">
                <td data-label="Select">
                  <input type="checkbox" />
                </td>
                <td data-label="Attendee Name">
                  {{ `${person.first_name} ${person.last_name}` }}
                </td>
                <td data-label="Email">{{ person.email }}</td>
                <td data-label="Attending">{{ person.status }}</td>
                <td data-label="Edit" @click="openEdit(person)" class="active">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.9007 2.65104L13.6731 0.421572C13.1119 -0.140164 12.1355 -0.141243 11.572 0.422651L1.59285 10.5003C1.54861 10.5449 1.51669 10.5998 1.49929 10.66L0.0142498 15.8621C-0.0227491 15.9917 0.0135189 16.1314 0.108888 16.2268C0.179579 16.2976 0.274217 16.3357 0.371395 16.3357C0.405471 16.3357 0.439929 16.331 0.473273 16.3215L5.67098 14.8352C5.73116 14.8178 5.78591 14.7859 5.83049 14.7416L15.9007 4.75281C16.1813 4.47196 16.3358 4.09891 16.3358 3.70194C16.3358 3.30498 16.1813 2.93189 15.9007 2.65104ZM9.95418 3.12333L11.3208 4.48996L4.18569 11.6251L3.67363 10.6006C3.61052 10.4748 3.48219 10.3954 3.34151 10.3954H2.74695L9.95418 3.12333ZM0.911969 15.4238L1.39557 13.7309L2.6048 14.9402L0.911969 15.4238ZM5.19782 14.1994L3.42149 14.7069L1.62887 12.9143L2.13631 11.1379H3.11196L3.75187 12.4178C3.78776 12.4896 3.84613 12.548 3.91793 12.5838L5.19779 13.2238V14.1994H5.19782ZM5.94038 13.5888V12.9943C5.94038 12.8536 5.86098 12.7253 5.73516 12.6622L4.71068 12.1501L11.8458 5.01497L13.2124 6.3816L5.94038 13.5888ZM15.3768 4.23653L13.7398 5.85895L10.4768 2.59598L12.0981 0.960057C12.3788 0.679416 12.8675 0.679416 13.1481 0.960057L15.3757 3.18765C15.516 3.32795 15.5933 3.5143 15.5933 3.71263C15.5933 3.91096 15.516 4.09731 15.3768 4.23653Z"
                      fill="#FBA500"
                    />
                  </svg>
                </td>
              </tr>
            </tbody>
            <p>
              <!-- <button @click="prevPage">Previous</button>
              <button @click="nextPage">Next</button>-->
            </p>
          </table>
        </div>
      </div>
      <div class="guestlist-popup">
        <div class="guestlist-popup">
          <Popup :title="'Add Guest'" :show="showPopup">
            <div class="guest-tickets">
              <h4>Choose Ticket:</h4>
              <div v-for="ticket in tickets" :key="ticket.id" class="input">
                <span class="ticket-type">{{ ticket.name }}</span>
                <div class="ticket-quantity">
                  <button
                    :disabled="init_edit"
                    @click="handleQuantities(ticket.id, -1)"
                  >
                    -
                  </button>
                  <input
                    disabled
                    type="text"
                    v-model="selectedTickets[ticket.id]"
                  />
                  <button
                    :disabled="init_edit"
                    @click="handleQuantities(ticket.id, 1)"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            <div class="inputs">
              <div class="input">
                <label>First Name</label>
                <input v-model="guest.first_name" type="text" />
              </div>
              <div class="input">
                <label>Last Name</label>
                <input v-model="guest.last_name" type="text" />
              </div>
              <div class="input">
                <label>Email </label>
                <input v-model="guest.email" type="email" />
                <p
                  style="
                    text-decoration: underline;
                    color: blue;
                    cursor: pointer;
                  "
                  @click="resendConfirmationEmail(guest)"
                  v-if="init_edit"
                >
                  Resend Tickets
                </p>
              </div>
              <div class="input">
                <label>Affiliation (optional)</label>
                <input v-model="guest.affiliation" type="text" />
              </div>
              <div class="input checkbox">
                <input
                  v-model="guest.notified"
                  type="checkbox"
                  id="notifcation"
                  name="notifcation"
                />
                <span for="notifcation">Notification Upon Arrival</span>
              </div>

              <hr />
            </div>
            <div class="btns">
              <button @click="closePopup" class="btn text_btn">Cancel</button>
              <button @click="deleteGuest(guest)" v-if="init_edit" class="btn">
                Delete
              </button>
              <button v-else @click="validate" class="btn">Add Guest</button>
            </div>
          </Popup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import Popup from "../components/Popup";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
    Popup,
  },
  data() {
    return {
      sendEmail: functions.httpsCallable("sendEmail"),
      event: null,
      init_edit: false,
      showPopup: false,
      tickets: [],
      guests: [],
      progress: "0%",
      selectedTickets: {},
      unfilteredGuests: [],
      guest: {
        created_at: Date.now(),
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        order_id: null,
        register_date: null,
        approval_date: null,
        checkin_date: null,
        status: "PENDING",
        uid: null,
        affiliation: null,
        notified: false,
        checkedIn: false,
      },
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      tickets: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket"),
      guests: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guestlist"),
      unfilteredGuests: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guestlist"),
    };
  },
  watch: {
    tickets() {
      this.handleSelectedTickets();
    },
  },
  methods: {
    handleSearch(e) {
      let value = e.target.value.toLowerCase();
      if (value) {
        this.guests = this.unfilteredGuests.filter(
          (g) =>
            g.first_name.toLowerCase().includes(value) ||
            g.last_name.toLowerCase().includes(value) ||
            g.email.toLowerCase().includes(value)
        );
      } else {
        this.guests = this.unfilteredGuests;
      }
    },
    async resendConfirmationEmail(guest) {
      let loader = this.$loading.show({
        container: null,
        canCancel: true,
        onCancel: false,
      });
      this.guest = guest;
      this.selectedTickets = guest.selectedTickets;
      await this.sendConfirmationEmail();
      loader.hide();
    },
    sendConfirmationEmail() {
      let tickets = this.tickets
        .filter((t) => {
          return this.selectedTickets[t.id];
        })
        .map((t) =>
          Object.assign({
            quantity: this.selectedTickets[t.id],
            name: t.name,
            price: t.price,
          })
        );
      let ticket_quantity = tickets.reduce((a, b) => {
        return a + b.quantity;
      }, 0);
      let ticket_price = tickets.reduce((a, b) => {
        return a + b.quantity * b.price;
      }, 0);
      return this.sendEmail({
        template_name: "journey-guest-list-confirmation",
        from_email: null,
        to_email: [
          {
            email: this.guest.email,
            name: `${this.guest.first_name} ${this.guest.last_name}`,
            type: "to",
          },
        ],
        global_merge_vars: [
          {
            name: "buyer",
            content: `${this.guest.first_name} ${this.guest.last_name}`,
          },
          {
            name: "ticket_quantity",
            content: ticket_quantity,
          },
          {
            name: "event_img",
            content: this.event.event_image,
          },
          {
            name: "total_price",
            content: ticket_price,
          },
          {
            name: "date",
            content: moment(this.event.start_time).format("MMM Do YY"),
          },
          {
            name: "time",
            content: moment(this.event.start_time).format("h:mm:ss a"),
          },
          {
            name: "venue",
            content: this.event.title,
          },
          {
            name: "location",
            content: `${this.event.address.address_1} ${this.event.address.city} ${this.event.address.state} ${this.event.address.zip}`,
          },
          {
            name: "map_link",
            content: `https://www.google.com/maps/place/${this.event.address.address_1}+${this.event.address.city}+${this.event.address.state}+${this.event.address.zip}`,
          },
          {
            name: "event_link",
            content: `https://journey-landing.firebaseapp.com/${this.event.template_id}/${this.event.slug}`,
          },
          {
            name: "created_at",
            content: moment().format("MMM Do YY"),
          },
          {
            name: "order_number",
            content: this.guest.order_number,
          },
          {
            name: "line_item",
            content: tickets,
          },
          {
            name: "order_link",
            content: `https://journey-landing.firebaseapp.com/checkout/${this.event.id}/${this.guest.id}`,
          },
        ],
      }).then((res) => {
        Swal.fire("", "Email has been sent to guest", "success");
        return res;
      });
    },
    watch: {
      tickets() {
        this.handleSelectedTickets();
      },
    },
    closePopup() {
      this.showPopup = false;
      this.init_edit = false;
      this.guest = this.resetGuest;
      this.handleSelectedTickets();
    },
    openEdit(guest) {
      this.showPopup = true;
      this.guest = guest;
      this.init_edit = true;
      this.selectedTickets = guest.selectedTickets;
    },
    addGuest() {
      this.guest.selectedTickets = this.selectedTickets;
      this.guest.order_number = Math.random().toString(36).substr(0, 10);
      let loader = this.$loading.show({
        container: null,
        canCancel: true,
        onCancel: false,
      });

      let ref = db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guestlist")
        .doc();

      return ref
        .set(this.guest, {
          merge: true,
        })
        .then(() => {
          this.guest.id = ref.id;
          return this.sendConfirmationEmail();
        })
        .then(() => {
          this.closePopup();
          loader.hide();
        });
    },
    deleteGuest(guest) {
      return db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guestlist")
        .doc(guest.id)
        .delete()
        .then(() => this.closePopup());
    },
    handleQuantities(id, increment) {
      this.selectedTickets[id] += increment;
      this.$forceUpdate();
      if (this.selectedTickets[id] < 0) {
        this.selectedTickets[id] = 0;
      }
    },
    validate() {
      let valid = true;
      let ticket_count = 0;

      return ref
        .set(this.guest, {
          merge: true,
        })
        .then(() => {
          this.guest.id = ref.id;
          this.sendConfirmationEmail();
        });
    },
    deleteGuest(guest) {
      return db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guestlist")
        .doc(guest.id)
        .delete()
        .then(() => this.closePopup());
    },
    handleQuantities(id, increment) {
      this.selectedTickets[id] += increment;
      this.$forceUpdate();
      if (this.selectedTickets[id] < 0) {
        this.selectedTickets[id] = 0;
      }
    },
    validate() {
      let valid = true;
      let ticket_count = 0;

      for (const key in this.guest) {
        if (key == "first_name" || key == "last_name" || key == "email") {
          if (!this.guest[key]) valid = false;
        }
      }

      for (const key in this.selectedTickets) {
        ticket_count += this.selectedTickets[key];
      }

      if (valid) {
        if (!ticket_count) {
          return Swal.fire("You must select at lease one ticket");
        }
        return this.addGuest();
      } else {
        return Swal.fire(
          "Missing Fields! (*)",
          "Please fill in all required fields (*)",
          "warning"
        );
      }
    },
  },
  computed: {
    resetGuest() {
      return {
        created_at: Date.now(),
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        order_id: null,
        register_date: null,
        approval_date: null,
        checkin_date: null,
        status: "PENDING",
        uid: null,
        affiliation: null,
        notified: false,
      };
    },
  },
};
</script>

<style lang="scss">
.info-search {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .search-inp {
    width: 35%;
  }
}

.guestlist-popup {
  .holder {
    max-width: 390px !important;
    height: 630px !important;

    &::-webkit-scrollbar {
      display: none;
    }

    .inputs {
      // flex-direction: column;
      height: 440px !important;
    }
  }

  .input {
    width: 100% !important;

    &.checkbox {
      padding: 20px 0;
    }
  }

  .guest-tickets {
    width: 100%;

    .input {
      border-bottom: 1px solid rgba(0, 0, 0, 0.5);
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      padding-bottom: 13px;

      .ticket-type {
        opacity: 0.7;
      }

      .ticket-quantity {
        display: flex;
        flex-direction: row;

        button {
          color: #fba500;
          background: transparent;
          border: unset;
          font-size: 16px;

          &:hover {
            cursor: pointer;
          }

          &:focus {
            outline: none !important;
          }
        }

        input {
          max-width: 40px;
          height: 30px;
          padding: unset;
          text-align: center;
        }
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .info-search {
    flex-wrap: wrap;

    div {
      width: 100%;
    }

    .search-inp {
      margin: 20px 0 0 0;
      width: 100%;
    }
  }
}
</style>
